import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    heightPercentageToDP,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const SIZES = {
    width: Platform.select({
        default: widthPercentageToDP(104, 132),
        web: 176,
    }),
    height: Platform.select({
        default: heightPercentageToDP(59, 74),
        web: 99,
    }),
    widthSelected: Platform.select({
        default: widthPercentageToDP(132, 160),
        web: 204,
    }),
    heightSelected: Platform.select({
        default: heightPercentageToDP(75, 90),
        web: 115,
    }),
    spacing: 8,
};

const styles = StyleSheet.create({
    root: {
        width: SIZES.width,
        height: SIZES.height,
        borderRadius: 5,
        marginHorizontal: SIZES.spacing,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: isWeb ? 0 : SIZES.heightSelected - SIZES.height,
    },
    selected: {
        borderWidth: 4,
        borderColor: COLOR.NEUTRAL,
        width: SIZES.widthSelected,
        height: SIZES.heightSelected,
        marginLeft: isWeb ? 6 : -SIZES.spacing,
        alignSelf: 'center',
        marginTop: 0,
        zIndex: 1000,
    },
    text: {
        position: 'absolute',
        left: 4,
        top: 4,
        width: '100%',
    },
    iconContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        width: 50,
        height: 32,
    },
    channelName: {
        paddingHorizontal: 5,
        lineHeight: 14,
        maxWidth: SIZES.width,
        height: 'auto',
    },
    channelCard: {
        width: '100%',
        height: '100%',
    },
});

export default styles;
